import ScheduleHandler from "../Database/handlers/ScheduleHandler"
import { ITodo, ITodoSchedule, schedule, TodoObj } from "../types/interfaces"
const scheduleHandler = new ScheduleHandler()
export default function CreateCalendarData(currentMonth: number, currentYear: number,schedules:ITodoSchedule[]) {
  console.log("created calednar")
  

    let elements:{id:string,content:string,todos:ITodo[]}[][] = []
    const lastDateOfMonth = new Date(currentYear, currentMonth+1, 0).getDate()
    let rows:{id:string,content:string,todos:ITodo[]}[] = []
    let CurrentWeekDay = new Date(currentYear, currentMonth, 1).getDay()
    let currentMonthName = new Date(currentYear, currentMonth, 1).toLocaleString("en-us", { month: "long" })
    // Adds 1st week's remaining days
    for (let i = 0; i < CurrentWeekDay; i++){
      rows.push({id:"None",content:"",todos:[]})
    }
    // Adds the month's days
  
  for (let i = 1; i <= lastDateOfMonth; i++){
    const date =`${currentMonthName} ${i}, ${currentYear}`
    const filteredSchedules = schedules.filter((schedule) => {
      const scheduleDate = schedule.scheduleDate.toString()
      return scheduleDate == date
    })
    let todosArr:ITodo[] = []
    filteredSchedules.forEach((schedule) => {
      todosArr.push(...schedule.todosArr)
    })

    rows.push({
      id: `${date}`, content: `${i}`, todos: todosArr
    }) 
      if (rows.length%7 == 0 || i == lastDateOfMonth){
        elements.push(rows)
        rows = []
    }
    // scheduleHandler.FetchSchedule(date).then((data) => {
    //   console.log(data)
    //   rows.push({ id: date, content: `${i}` ,todos:data.todosArr})
      
    //   if (rows.length%7 == 0 || i == lastDateOfMonth){
    //     elements.push(rows)
    //     rows = []
    //   }
    // }, () => {
    //   rows.push({ id: date, content: `${i}` ,todos:[]})
      
    //   if (rows.length%7 == 0 || i == lastDateOfMonth){
    //     elements.push(rows)
    //     rows = []
        
    //   }
    // })
    }
    return elements
}
